import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-chidalu',
  templateUrl: './footer-chidalu.component.html',
  styleUrls: ['./footer-chidalu.component.scss'],
  standalone: true,
})
export class FooterChidaluComponent {
  get currentYear() {
    return new Date().getFullYear();
  }
}
